import { isValidPrice } from '@domain-group/javascript-utils'

import type { CustomItemGroupModel } from '@models/types'

export type CustomItemModel = {
  agency_id: number,
  cache_key: number,
  custom_item_group?: CustomItemGroupModel,
  custom_item_group_id: number,
  description?: string,
  id: number,
  price: number,
  price_override: number,
  title: string,
}

export type CustomItemRequestOptions = {}

const state = {
  agency_id: undefined,
  custom_item_group_id: undefined,
  description: undefined,
  id: null,
  price: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'custom_item_group_id' },
  { key: 'price', validation: isValidPrice, invalidMessage: 'Invalid Value' },
  { key: 'title' },
]

export default state
